import {
  getDropboxAutoConnectEligibility,
  getDropboxAutoConnectRedirectUrl,
} from "@mirage/service-onboarding-surveys";
import { useEffect, useState } from "react";

import type { UIConnection, UIConnector } from "@mirage/shared/types";

type DropboxAutoConnectState = "disabled" | "disconnected" | "connected";

export const isDropboxConnector = (connector: UIConnector | UIConnection) => {
  return "id_attrs" in connector && connector.id_attrs?.type === "dropbox";
};

export function useDropboxAutoConnect(
  allConnectors: (UIConnector | UIConnection)[],
) {
  const [dropboxAutoConnectState, setDropboxAutoConnectState] =
    useState<DropboxAutoConnectState>("disabled");

  useEffect(() => {
    getDropboxAutoConnectEligibility()
      .then((res) => {
        if (res) {
          setDropboxAutoConnectState("connected");
        }
        return;
      })
      .catch(() => {
        // Treat as non-eligible and do not block onboarding
        // TODO: log error
        return;
      });
  }, []);

  const handleDropboxAutoConnect = (nextStepUrl: string) => {
    const actualDropboxConnector = allConnectors?.find(isDropboxConnector);
    if (
      actualDropboxConnector &&
      "id_attrs" in actualDropboxConnector &&
      actualDropboxConnector.id_attrs?.id
    ) {
      return getDropboxAutoConnectRedirectUrl(
        actualDropboxConnector.id_attrs.id,
        nextStepUrl,
      ).then((redirectUrl) => {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
        return;
      });
    }
  };
  return {
    dropboxAutoConnectState,
    setDropboxAutoConnectState,
    handleDropboxAutoConnect,
  };
}
